<!--
 * @Author: aisi
 * @Date: 2020-01-04 09:44:40
 * @LastEditTime : 2020-01-07 15:03:12
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/analyseWord/studySurvey/CourseAverage.vue
-->
<template>
  <div class="line">
    <div :id="id" style="height:350px"></div>
  </div>
</template>
<script>
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
// 引入折线图
require('echarts/lib/chart/line')
// 引入图表标线
require('echarts/lib/component/markLine')
export default {
  props: ['id', 'color', 'data', 'seriesData'],

  mounted() {
    let dom = echarts.init(document.getElementById(this.id), null, {
      renderer: 'svg'
    })
    dom.setOption({
      color: this.color,
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.data
      },
      yAxis: {
        type: 'value',
        name: '稳定性',
        max: 100
      },
      series: [
        {
          name: '全A+',
          data: this.seriesData,
          type: 'line',
          label: {
            show: true
          }
        }
      ]
    })
  }
}
</script>
<style lang="scss" scoped></style>
